var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PublicKey } from "@solana/web3.js";
import { checkEnvOpts } from "../utils/check";
import { bidToscBid } from "../utils/typeSwap";
import { DESC } from "../utils/descriptions";
import { ix2vTx } from "../utils/vtx";
import { getSdaData } from "../utils/getSdaData.function";
import { findOrCreateAta } from "../utils/findOrCreateAta.function";
import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { WRAPPED_SOL_MINT } from "@metaplex-foundation/js";
import { addWSol } from "../utils/wsol";
export function createAddBidIx(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var bids, swapDataAccount, maker, paymentMint, makerTokenAta, swapDataAccountTokenAta, cEnvOpts, program, connection, clusterOrUrl, ataIxs, sdaData, _a, pmakerTokenAta, mt, _b, pswapDataAccountTokenAta, sdat, paymentSdaTokens, _c, highestBid_1, amountToWrap, error_1;
        var _d;
        var _this = this;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    bids = Data.bids, swapDataAccount = Data.swapDataAccount, maker = Data.maker, paymentMint = Data.paymentMint, makerTokenAta = Data.makerTokenAta, swapDataAccountTokenAta = Data.swapDataAccountTokenAta;
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    cEnvOpts = _e.sent();
                    program = cEnvOpts.program, connection = cEnvOpts.connection, clusterOrUrl = cEnvOpts.clusterOrUrl;
                    ataIxs = [];
                    bids = bids.sort(function (v1, v2) {
                        var bidAmount1 = v1.makerNeoswapFee + v1.makerRoyalties + Math.max(-v1.amount, 0);
                        var bidAmount2 = v2.makerNeoswapFee + v2.makerRoyalties + Math.max(-v2.amount, 0);
                        return bidAmount1 - bidAmount2;
                    });
                    if (!!(paymentMint && makerTokenAta && swapDataAccountTokenAta)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getSdaData({ clusterOrUrl: clusterOrUrl, swapDataAccount: swapDataAccount })];
                case 2:
                    sdaData = _e.sent();
                    if (sdaData === null || sdaData === void 0 ? void 0 : sdaData.paymentMint)
                        paymentMint = sdaData.paymentMint;
                    else
                        throw "paymentMint not found";
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: maker,
                            signer: maker,
                        })];
                case 3:
                    _a = _e.sent(), pmakerTokenAta = _a.mintAta, mt = _a.instruction;
                    if (mt)
                        ataIxs.push(mt);
                    else
                        console.log("pmakerTokenAta", pmakerTokenAta);
                    makerTokenAta = pmakerTokenAta;
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: swapDataAccount,
                            signer: maker,
                        })];
                case 4:
                    _b = _e.sent(), pswapDataAccountTokenAta = _b.mintAta, sdat = _b.instruction;
                    if (sdat)
                        ataIxs.push(sdat);
                    else
                        console.log("pswapDataAccountTokenAta", pswapDataAccountTokenAta);
                    swapDataAccountTokenAta = pswapDataAccountTokenAta;
                    _e.label = 5;
                case 5:
                    if (!(paymentMint == WRAPPED_SOL_MINT.toString())) return [3 /*break*/, 9];
                    _e.label = 6;
                case 6:
                    _e.trys.push([6, 8, , 9]);
                    _c = Number;
                    return [4 /*yield*/, connection.getTokenAccountBalance(new PublicKey(swapDataAccountTokenAta))];
                case 7:
                    paymentSdaTokens = _c.apply(void 0, [(_e.sent())
                            .value.amount]);
                    highestBid_1 = 0;
                    bids.forEach(function (bid) {
                        var bidAmount = bid.makerNeoswapFee + bid.makerRoyalties + Math.max(-bid.amount, 0);
                        console.log("Math.max(-bid.amount, 0)", Math.max(-bid.amount, 0));
                        if (bidAmount > highestBid_1) {
                            highestBid_1 = bidAmount;
                        }
                    });
                    if (highestBid_1 > paymentSdaTokens) {
                        amountToWrap = highestBid_1 - paymentSdaTokens;
                        console.log("amountToWrap", amountToWrap);
                        ataIxs.push.apply(ataIxs, addWSol(maker, makerTokenAta, amountToWrap));
                    }
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _e.sent();
                    if (!String(error_1).includes("could not find account"))
                        throw error_1;
                    return [3 /*break*/, 9];
                case 9:
                    _d = {};
                    return [4 /*yield*/, Promise.all(bids.map(function (bid) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, program.methods
                                            .addBid(bidToscBid(bid))
                                            .accountsStrict({
                                            swapDataAccount: swapDataAccount,
                                            maker: maker,
                                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                                            makerTokenAta: makerTokenAta,
                                            tokenProgram: TOKEN_PROGRAM_ID,
                                        })
                                            .instruction()];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 10: return [2 /*return*/, (_d.bidIxs = _e.sent(),
                        _d.ataIxs = ataIxs,
                        _d)];
            }
        });
    });
}
export function createAddBidBt(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var bidIxs, ixs, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, createAddBidIx(Data)];
                case 1:
                    bidIxs = _d.sent();
                    ixs = [];
                    if (bidIxs.ataIxs)
                        ixs.push.apply(ixs, bidIxs.ataIxs);
                    ixs.push.apply(ixs, bidIxs.bidIxs);
                    _c = {
                        description: DESC.addBid
                    };
                    _a = ix2vTx;
                    _b = [ixs];
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_d.sent(), Data.maker]))];
                case 3: return [2 /*return*/, (_c.tx = _d.sent(),
                        _c.details = Data,
                        _c.priority = 0,
                        _c.status = "pending",
                        _c)];
            }
        });
    });
}
export function createRmBidIx(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var rmBids, swapDataAccount, maker, paymentMint, makerTokenAta, swapDataAccountTokenAta, cEnvOpts, program, connection, clusterOrUrl, ataIxs, sdaData, _a, pmakerTokenAta, mt, _b, pswapDataAccountTokenAta, sdat;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    rmBids = Data.rmBids, swapDataAccount = Data.swapDataAccount, maker = Data.maker, paymentMint = Data.paymentMint, makerTokenAta = Data.makerTokenAta, swapDataAccountTokenAta = Data.swapDataAccountTokenAta;
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    cEnvOpts = _c.sent();
                    program = cEnvOpts.program, connection = cEnvOpts.connection, clusterOrUrl = cEnvOpts.clusterOrUrl;
                    ataIxs = [];
                    if (!!(paymentMint && makerTokenAta && swapDataAccountTokenAta)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getSdaData({ clusterOrUrl: clusterOrUrl, swapDataAccount: swapDataAccount })];
                case 2:
                    sdaData = _c.sent();
                    if (sdaData === null || sdaData === void 0 ? void 0 : sdaData.paymentMint)
                        paymentMint = sdaData.paymentMint;
                    else
                        throw "paymentMint not found";
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: maker,
                            signer: maker,
                        })];
                case 3:
                    _a = _c.sent(), pmakerTokenAta = _a.mintAta, mt = _a.instruction;
                    if (mt)
                        ataIxs.push(mt);
                    else
                        console.log("pmakerTokenAta", pmakerTokenAta);
                    makerTokenAta = pmakerTokenAta;
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: swapDataAccount,
                            signer: maker,
                        })];
                case 4:
                    _b = _c.sent(), pswapDataAccountTokenAta = _b.mintAta, sdat = _b.instruction;
                    if (sdat)
                        ataIxs.push(sdat);
                    else
                        console.log("pswapDataAccountTokenAta", pswapDataAccountTokenAta);
                    swapDataAccountTokenAta = pswapDataAccountTokenAta;
                    _c.label = 5;
                case 5: return [4 /*yield*/, Promise.all(rmBids.map(function (bid) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, program.methods
                                        .removeBid(bidToscBid(bid))
                                        .accountsStrict({
                                        swapDataAccount: swapDataAccount,
                                        maker: maker,
                                        // swapDataAccountTokenAta,
                                        // makerTokenAta,
                                        // tokenProgram: TOKEN_PROGRAM_ID,
                                    })
                                        .instruction()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }))];
                case 6: return [2 /*return*/, _c.sent()];
            }
        });
    });
}
export function createRmBidBt(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _c = {
                        description: DESC.rmBid
                    };
                    _a = ix2vTx;
                    return [4 /*yield*/, createRmBidIx(Data)];
                case 1:
                    _b = [_d.sent()];
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 2: return [4 /*yield*/, _a.apply(void 0, _b.concat([_d.sent(), Data.maker]))];
                case 3: return [2 /*return*/, (_c.tx = _d.sent(),
                        _c.details = Data,
                        _c.priority = 0,
                        _c.status = "pending",
                        _c)];
            }
        });
    });
}
